// extracted by css-extract-rspack-plugin
export default {"error":"P8trg"};